module.exports = __webpack_public_path__ + "static/media/vehicleregistrationback.53cdfcdb.jpg";